import { combineReducers } from 'redux';
import loader from './loader/reducer';
import loaded from './loaded/reducer';

export default combineReducers({
  loader,
  loaded,
});
